import { gql } from '@apollo/client';

export const QUERY = gql`
  query membersCustomDataPaged($tsDivisionId: Int!, $pageNumber: Int!, $pageSize: Int!) {
    membersCustomDataPaged(tsDivisionId: $tsDivisionId, pageNumber: $pageNumber, pageSize: $pageSize) {
      __typename
      data {
        id
        value
        memberId
        leagueCustomFieldId
      }
      metadata {
        pageNumber
        pageSize
        totalEntries
        totalPages
      }
    }
  }
`;
